export default __webpack_public_path__ + "static/media/018_photo.2ad49da8.jpg";